import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { getNFeConfig, updateNFeConfig } from "../../../../api/nfe";
import { Input, Button, Typography, Select } from "../../../../design-system";
import { colors } from "../../../../design-system/theme/colors";
import { showSnackBar } from "../../../../utils";
import { toast } from "react-toastify";

const NFCeConfig = () => {
  const [config, setConfig] = useState({});
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState({
    show: false,
    title: "",
    description: ""
  });

  const fetchNFeConfig = async () => {
    setLoading(true);
    try {
      const fetchedConfig = await getNFeConfig();
      setConfig(fetchedConfig);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNFeConfig();
    window.scrollTo({ top: 0 });
  }, []);

  const updateLocalStorage = () => {
    let branch = window.localStorage.getItem("easygestorweb_current_branch") || undefined;
    if (branch) {
      branch = JSON.parse(branch);
      branch["fiscal_config"] = config;
      window.localStorage.setItem("easygestorweb_current_branch", JSON.stringify(branch));
    }
  };

  const handleUpdateNFeConfig = async () => {
    setLoading(true);
    const configToUpdate = { ...config };
    
    // Fallback logic from original code
    if (!configToUpdate.nfce_id_csc && configToUpdate.nfce_csc_token) {
      configToUpdate.nfce_id_csc = "00001";
      setConfig(configToUpdate);
    }

    try {
      await updateNFeConfig(configToUpdate);
      updateLocalStorage();
      
      let href = window.location.pathname;
      const redirect = () => window.location.href = href;
      if (window.location.search.includes("from=")) {
        href = window.location.search.split("from=")[1];
      }
      
      toast.success("Configurações atualizadas", {
        toastId: "update-nfce-settings-toast"
      });
      setTimeout(redirect, 3000);
    } catch (error) {
      setModal({
        show: true,
        title: "Oops...",
        description: "Ocorreu um erro ao tentar salvar as configurações, por favor revise as informações e tente novamente."
      });
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setConfig((prevConfig) => ({
      ...prevConfig,
      [name]: value
    }));
  };

  const danfeOptions = [
    { value: "1", label: "Bobina Térmica" },
    { value: "2", label: "A4" }
  ];

  return (
    <div className="container-fluid py-4">
      <div className="row mb-5">
        <div className="col-12 py-3 border-bottom mb-4">
          <Typography variant="articleTitle" style={{ color: colors.brandDarkBlue }}>
            Configurações para emissão de NFC-e
          </Typography>
          <Typography variant="paragraph" style={{ color: colors.brandMediumGray, display: 'block', marginTop: '4px' }}>
            Ajuste as parametrizações fiscais padronizadas para suas notas de consumidor.
          </Typography>
        </div>
        
        {/* Seção 1: Dados de Emissão */}
        <div className="col-12 mb-3">
            <Typography variant="cardTitle" style={{ color: colors.brandDarkBlue, borderBottom: `2px solid ${colors.brandOffWhite}`, paddingBottom: '0.5rem' }}>
              Dados de Emissão
            </Typography>
        </div>
      </div>
      
      <div className="row mb-4">
        <div className="col-md-4 col-sm-6 col-12 mb-3">
          <Input
            name="nfce_number"
            label="Número"
            placeholder="Número da NFC-e"
            value={config.nfce_number || ''}
            onChange={handleChange}
            disabled={loading}
          />
        </div>
        
        <div className="col-md-4 col-sm-6 col-12 mb-3">
          <Input
            name="nfce_serie"
            label="Série"
            placeholder="Série para emissão da NFC-e"
            value={config.nfce_serie || ''}
            onChange={handleChange}
            disabled={loading}
          />
        </div>

        <div className="col-md-4 col-sm-6 col-12 mb-3">
          <Select
            name="nfce_danfe_orientation"
            label="Modelo de impressão da DANFE"
            options={danfeOptions}
            value={config.nfce_danfe_orientation || "1"}
            onChange={handleChange}
            disabled={loading}
          />
        </div>
      </div>

      <div className="row mb-5">
        {/* Seção 2: Credenciais Sefaz */}
        <div className="col-12 mb-3 mt-2">
            <Typography variant="cardTitle" style={{ color: colors.brandDarkBlue, borderBottom: `2px solid ${colors.brandOffWhite}`, paddingBottom: '0.5rem' }}>
              Credenciais de Acesso (SEFAZ)
            </Typography>
        </div>
        <div className="col-md-4 col-sm-6 col-12 mb-3">
          <Input
            name="nfce_id_csc"
            label="ID CSC"
            placeholder="Ex: 00001"
            value={config.nfce_id_csc || ''}
            onChange={handleChange}
            disabled={loading}
          />
        </div>

        <div className="col-md-8 col-sm-6 col-12 mb-3">
          <Input
            name="nfce_csc_token"
            label="Código CSC"
            placeholder="Código de Segurança do Contribuinte"
            value={config.nfce_csc_token || ''}
            onChange={handleChange}
            disabled={loading}
          />
        </div>
      </div>

      {/* Footer Actions */}
      <div className="row mt-4 pt-3 border-top">
        <div className="col-12 d-flex justify-content-end">
          <Button
            variant="primary"
            onClick={handleUpdateNFeConfig}
            disabled={loading}
          >
             {loading ? "Salvando..." : "Salvar Configurações"}
          </Button>
        </div>
      </div>

      <Modal show={modal.show} onHide={() => window.location.reload()}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Typography variant="cardTitle" as="h3">
              {modal.title}
            </Typography>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Typography variant="paragraph" as="p">
            {modal.description}
          </Typography>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => window.location.reload()}>
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default NFCeConfig;


// WEBPACK FOOTER //
// ./src/views/Fiscal/NFCe/config/index.jsx